export default __webpack_public_path__ + "static/media/Sprints_Main.c8eb3580.png";